import {GET_HOT_MATCHES} from "../../../constants/HotMatchConstants";
import {SettingsObject} from "../../../@types/response";
import {GeneralAction} from "../../../@types/actions";

export const GetHotMatchesAction = (settings: SettingsObject): GeneralAction<SettingsObject> => ({
    type: GET_HOT_MATCHES,
    payload: settings
});